import { createMutation } from "@/mutations";
import { resetPassword } from "@/features/auth/api/session";
import type { ResetPasswordPayload } from "@/features/auth/api/session";
import type { AxiosResponse } from "axios";

type ResetPasswordResponse = Awaited<ReturnType<typeof resetPassword>> extends AxiosResponse<infer T>
  ? T
  : never;

export const useResetPasswordMutation = () => {
  return createMutation<ResetPasswordResponse, ResetPasswordPayload>({
    mutationFn: async (payload) => {
      const response = await resetPassword(payload);
      return response.data;
    },
    invalidateQueries: (key) => Array.isArray(key) && key[0] === "userInfo",
  });
};

